import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Seo } from "@/components/layout/Seo";
import { Reveal, Overline } from "@/components/Reveal";
import { FinalCta } from "@/components/sections/CallToActions";
import { useLang } from "@/context/LanguageContext";

const PASTELS = ["bg-pastel-violet", "bg-pastel-blue", "bg-pastel-yellow"];

export default function ElSalvadorUsaPage() {
  const { lang, t } = useLang();
  const d = t.diasporaPage;
  return (
    <>
      <Seo page="diaspora" />
      <section className="py-14 md:py-20" data-testid="diaspora-index">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <Reveal className="mb-10 md:mb-14">
            <img
              src="/assets/diaspora-header.webp"
              alt={d.imageAlt}
              data-testid="diaspora-header-image"
              className="w-full aspect-[5/2] object-cover"
            />
          </Reveal>
          <Reveal className="max-w-3xl mb-14 md:mb-20">
            <Overline>{d.overline}</Overline>
            <h1 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.08] tracking-tight text-navy mt-4">
              {d.title}
            </h1>
          </Reveal>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-testid="diaspora-cards">
            {d.sections.map((s, i) => (
              <Reveal key={s.id} delay={0.06 * (i % 3)}>
                <Link
                  to={`/${lang}/el-salvador-ee-uu/${s.id}`}
                  data-testid={`diaspora-card-${s.id}`}
                  className={`group flex flex-col h-full ${PASTELS[i % 3]} border border-navy/10 p-8 hover:border-ser-purple/40 hover:-translate-y-1 hover:shadow-[0_18px_40px_-18px_rgba(24,26,48,0.25)] transition-[transform,box-shadow,border-color] duration-300`}
                >
                  <h2 className="font-display text-2xl leading-snug text-navy group-hover:text-ser-purple transition-colors">
                    {s.title}
                  </h2>
                  <p className="mt-3 text-sm leading-relaxed text-navy/65 flex-1">{s.summary}</p>
                  <span className="mt-6 inline-flex items-center gap-2 text-xs uppercase tracking-[0.15em] font-medium text-ser-purple">
                    {d.viewAll}
                    <ArrowRight size={14} strokeWidth={1.5} className="transition-transform group-hover:translate-x-1" aria-hidden="true" />
                  </span>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <FinalCta />
    </>
  );
}
